import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import advanceFilterIcon from '../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../component/ui/Button';
import { bulkUpdateCurrencyOrPaymentTerms } from '../../store/action/vendor';
import { toast } from 'react-toastify';
import { ExportTable } from '../../store/action/export/Export';
import {
	changeIsActiveStatus,
	deleteVendorService,
	exportVendorTableData,
	getVendors,
} from '../../services/vendor';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import './Vendors.scss';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import VendorTable from './components/VendorTable';
import DeleteVendorModal from './components/DeleVendorModal';
import VendorAdvanceFilter from './components/VendorAdvanceFilter';
import VendorCurrencyModal from './components/VendorCurrencyModal';
import VendorBulkPaymentTermModal from './components/VendorBulkPaymentTermModal';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { formatFilterName, getFiltersParams } from '../../helper';
import { hasPermission } from '../../utils/controller';
import { Plus } from 'lucide-react';

const Vendors = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [searchParams, setSearchParams] = useSearchParams();
	const [totalPages, setTotalPages] = useState(0);
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('All Vendor');
	const [openPaymentTermsModal, setOpenPaymentTermsModal] = useState(false);
	const [openCurrencyModal, setCurrencyModal] = useState(false);
	const [showBulkOptions, setShowBulkOptions] = useState(false);
	const [sortDirection, setSortDirection] = useState({ vendor_name: 'asc' });
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const [selectedVendorsListForDelete, setSelectedVendorsListForDelete] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [statusToUpdate, setStatusToUpdate] = useState(null);
	const [isExportVendorLoading, setIsExportVendorLoading] = useState(false);
	const [vendorParams, setVendorParams] = useState({
		page: Number(searchParams.get('page')) || 1,
		pageSize: Number(searchParams.get('pageSize')) || 20,
		orderBy: searchParams.get('orderBy') || 'created_at',
		sortBy: searchParams.get('sortBy') || 'desc',
		filters: {},
	});
	const [deselectRows, setDeselectRows] = useState(null);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	async function handleExportVendor() {
		try {
			setIsExportVendorLoading(true);
			await exportVendorTableData(bulkAction.join(','));
			setBulkAction([]);
			deselectRows && deselectRows();
			toast.success('Excel file downloaded.');
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsExportVendorLoading(false);
		}
	}

	const FilterDatalist = (dropDownData) => {
		if (dropDownData === 'All Vendor') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Vendor');
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'Inactive Vendor', value: 'Inactive Vendor' },
			{ key: 'Active Vendor', value: 'Active Vendor' },
			{ key: 'Draft Vendor', value: 'Draft Vendor' },
		];

		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const handleSort = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setVendorParams((prev) => ({
				...prev,
				orderBy: param?.orderBy,
				sortBy: newDirection,
			}));
		}
	};

	const vendorColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => handleSort({ orderBy: 'vendor_name', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.vendor_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const nameAndStatus = params.data?.NAME || '';
				const [name, status] = nameAndStatus.split('|');

				if (status) {
					return (
						<p>
							{name}
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								{status}
							</span>
						</p>
					);
				}
				return <p>{name}</p>;
			},
		},
		{
			field: 'VENDOR DISPLAY NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 250,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => handleSort({ orderBy: 'vendor_display_name', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								VENDOR DISPLAY NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.vendor_display_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			flex: 1,
			cellClass: 'left-align',
		},
		{
			field: 'WORK PHONE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 130,
			maxWidth: 130,
			cellClass: 'left-align',
		},
		{
			field: 'PAYABLE',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 130,
			cellClass: 'right-align',
		},
		{
			field: 'Due - Next 15 Days',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 130,
			cellClass: 'right-align',
		},
	];

	const navigateRouter = (path) => {
		navigate(path);
	};

	const onRowClick = (id) => {
		if (id && hasPermission('purchases.vendors.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/vendor-create/${id}`);
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		} else {
			setVendorParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				vendor_ids: bulkAction,
				status,
			};
			setLoader(true);

			await changeIsActiveStatus(formbody);

			toast.success('Status Changes Successfully');
			setVendorParams((prev) => ({
				...prev,
				filters: {
					...prev.filters,
					status: headerDropDown === 'All Vendor' ? null : status ? 0 : 1,
				},
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const triggerConfirmationModal = (status) => {
		setStatusToUpdate(status);
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
		setStatusToUpdate(null);
	};

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark these {bulkAction.length} vendors as{' '}
					{statusToUpdate === 1 ? 'Active' : 'Inactive'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{tableData
						.filter((vendor) => bulkAction.includes(vendor.id))
						.map((vendor, index) => (
							<p key={vendor.id}>
								{index + 1}. {vendor.NAME}
							</p>
						))}
				</div>
			</div>
		);
	};

	const getModalTitle = () => {
		if (statusToUpdate === 1) {
			return 'Mark as Activate Vendors ';
		} else if (statusToUpdate === 2) {
			return 'Mark as Inactivate Vendors';
		}
		return 'Confirm Action';
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	const handleBulkPaymentTermsUpdate = (payment_terms) => {
		if (bulkAction.length === 0) {
			toast.error('Please select vendors!');
			return;
		}
		if (payment_terms) {
			const obj = {
				vendor_ids: bulkAction,
				payment_terms,
			};
			dispatch(bulkUpdateCurrencyOrPaymentTerms(obj))
				.then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						getAllVendor();
						setBulkAction([]);
						deselectRows && deselectRows();
					} else {
						toast.error(res?.message || 'Something went wrong');
					}
				})
				.catch((err) => {
					toast.error(err?.message || 'Something went wrong');
				});
			setOpenPaymentTermsModal(false);
		}
	};

	const handleBulkCurrencyUpdate = (currency) => {
		if (bulkAction.length === 0) {
			toast.error('Please select vendors!');
			return;
		}
		if (currency) {
			const obj = {
				vendor_ids: bulkAction,
				currency,
			};
			dispatch(bulkUpdateCurrencyOrPaymentTerms(obj))
				.then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						setBulkAction([]);
						deselectRows && deselectRows();
						getAllVendor();
					} else {
						toast.error(res?.message || 'Something went wrong');
					}
				})
				.catch((err) => {
					toast.error(err?.message || 'Something went wrong');
				});
			setCurrencyModal(false);
		}
	};

	const handleBulkActionClick = () => {
		setShowBulkOptions((prev) => !prev);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			const dropdown = document.getElementById('bulk-options-dropdown');
			if (showBulkOptions && dropdown && !dropdown.contains(event.target)) {
				setShowBulkOptions(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showBulkOptions]);

	async function handleBulkDelete() {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select vendors!');
				return;
			}
			await deleteVendorService(bulkAction);
			toast.success('Vendor Deleted Successfully.');
			setIsDeleteBulkConfirmationModalOpen(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			getAllVendor();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeleteVendorModal() {
		const selectedVendorsList = tableData?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(item.NAME);
				return acc;
			}
			return acc;
		}, []);
		setSelectedVendorsListForDelete(selectedVendorsList);
		setIsDeleteBulkConfirmationModalOpen(true);
	}

	function mappedTableData(data) {
		return data?.map((ele) => {
			let nameWithStatus = '';
			if (ele.status === 2) {
				nameWithStatus = `${ele.vendor_name} | Inactive`;
			} else if (ele.status === 0) {
				nameWithStatus = `${ele.vendor_name} | Draft`;
			} else {
				nameWithStatus = ele.vendor_name;
			}

			return {
				id: ele.vendor_id,
				NAME: nameWithStatus || 'N/A',
				'VENDOR DISPLAY NAME': ele?.vendor_display_name || 'N/A',
				'WORK PHONE': ele?.phone_mobile || 'N/A',
				PAYABLE: '₹' + Number(ele?.payables).toFixed(2),
				'Due - Next 15 Days': '₹' + Number(ele?.dueInNext15Days).toFixed(2),
			};
		});
	}

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];

		if (key !== 'status') {
			const data = await getVendors({ pageSize: 1000, filter: { key: '' } });
			selectInputData = data?.vendors
				?.filter((vendor) => vendor[key])
				?.map((vendor) => ({
					key: vendor[key],
					value: vendor[key],
				}));
		} else {
			selectInputData = [
				{ key: 'Inactive Vendor', value: 'Inactive Vendor' },
				{ key: 'Active Vendor', value: 'Active Vendor' },
				{ key: 'Draft Vendor', value: 'Draft Vendor' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'Inactive Vendor', value: 'Inactive Vendor' },
					{ key: 'Active Vendor', value: 'Active Vendor' },
					{ key: 'Draft Vendor', value: 'Draft Vendor' },
				];
			} else {
				const { vendors } = await getVendors({
					pageSize: 1000,
					filter: { key: value },
				});
				optionsList = vendors?.map((vendor) => ({
					key: vendor[key],
					value: vendor[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			setLoader(true);

			if (Object.keys(params).length === 0) {
				return;
			}
			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.status === 'Active Vendor') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Inactive Vendor') {
				updatedParams.status = 2;
			}

			if (updatedParams.status === 'Draft Vendor') {
				updatedParams.status = 0;
			}

			const { vendors, totalPages } = await getVendors({
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: updatedParams,
			});
			setTableData(mappedTableData(vendors));
			setTotalPages(totalPages);
			setIsAdvanceFilterOpen(false);
			dispatch(setAdvanceFilterTotalPage({ totalPages: totalPages }));
			setLoader(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		} finally {
			setLoader(false);
		}
	}

	const getAllVendor = async () => {
		try {
			setLoader(true);
			const { vendors, totalPages } = await getVendors(vendorParams);
			const data = mappedTableData(vendors);
			setTableData(data);
			setTotalPages(totalPages);
			setBulkAction([]);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	const setHeaderDropdownStatus = (filters) => {
		const statusMap = {
			0: 'Draft Vendor',
			1: 'Active Vendor',
			2: 'Inactive Vendor',
		};
		if (filters.status !== undefined) {
			setHeaderDropDown(statusMap[filters.status]);
		}
	};

	const setFilterFromUrl = () => {
		const filters = {};
		searchParams.forEach((value, key) => {
			if (key !== 'page' && key !== 'pageSize' && key !== 'orderBy' && key !== 'sortBy') {
				filters[key] = value;
			}
		});
		setSortDirection({
			[searchParams.get('orderBy')]: searchParams.get('sortBy') || '',
		});
		setHeaderDropdownStatus(filters);
		Object.entries(filters).forEach(([key, value]) => {
			const statusValueMap = {
				0: 'Draft Vendor',
				1: 'Active Vendor',
				2: 'Inactive Vendor',
			};
			const fieldValue = key === 'status' ? statusValueMap[value] : value;
			dispatch(
				setSelectedInput({
					key: key,
					label: formatFilterName(key),
				}),
			);
			dispatch(
				setSelectedInputValue({
					key: key,
					value: fieldValue,
				}),
			);
			handleOnFocusSelectedFilterInput(key);
		});
		if (Object.keys(filters).length > 0) {
			dispatch(
				setAdvanceFilter({
					isAdvanceFilterApplied: true,
					page: Number(searchParams.get('page')) || 1,
					pageSize: Number(searchParams.get('pageSize')) || 20,
					orderBy: searchParams.get('orderBy') || 'created_at',
					sortBy: searchParams.get('sortBy') || 'desc',
				}),
			);
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	function getParams(params) {
		const status = params.status;
		if (!status) return params;
		setHeaderDropDown(status);
		const statusMap = {
			'Draft Vendor': 0,
			'Active Vendor': 1,
			'Inactive Vendor': 2,
		};

		return {
			...params,
			status: statusMap[status],
		};
	}

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		// Normal params
		url.set('page', isAdvanceFilterApplied ? advanceFilterPage : vendorParams.page);
		url.set('pageSize', isAdvanceFilterApplied ? advanceFilterPageSize : vendorParams.pageSize);
		url.set('orderBy', isAdvanceFilterApplied ? advanceFilterOrderby : vendorParams.orderBy);
		url.set('sortBy', isAdvanceFilterApplied ? advanceFilterSortBy : vendorParams.sortBy);
		if (selectedInputs.length > 0) {
			const filters = getParams(getFiltersParams(selectedInputs));
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					url.set(key, value);
				}
			});
		} else {
			Object.entries(vendorParams.filters).forEach(([key, value]) => {
				url.set(key, value);
			});
		}
		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [
		vendorParams,
		selectedInputs,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
		isAdvanceFilterApplied,
	]);

	useEffect(() => {
		const stockFilterKeys = [
			'vendor_name',
			'vendor_display_name',
			'email',
			'phone_number',
			'status',
		];
		const hasStockFilter = stockFilterKeys.some((key) => searchParams.has(key));
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (!hasStockFilter) {
				getAllVendor();
			}
		}
	}, [searchParams, isAdvanceFilterApplied]);

	return (
		<div>
			{bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							button="Export"
							className="mt-0 px-4 btn-gray"
							disabled={!hasPermission('purchases.vendors.export', user?.role?.role_permissions)}
							loading={isExportVendorLoading}
							onClick={handleExportVendor}
						/>
						<Button
							type="button"
							button="Bulk Update"
							disabled={!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-gray relative"
							onClick={handleBulkActionClick}
						/>

						{showBulkOptions && (
							<div
								className="dropdown-menu show font-14"
								id="bulk-options-dropdown"
								style={{
									width: '114px',
									position: 'absolute',
									zIndex: 1000,
									maxHeight: '300px',
									overflowY: 'auto',
									marginTop: '120px',
									marginLeft: '80px',
								}}
							>
								<div
									style={{
										padding: '5px',
										cursor: 'pointer',
									}}
									className="dropdown-item"
									onClick={() => {
										setOpenPaymentTermsModal(true);
										setShowBulkOptions(false);
									}}
								>
									Payment Terms
								</div>
								<div
									style={{
										padding: '5px',
										cursor: 'not-allowed',
									}}
									className="dropdown-item"
									onClick={() => {
										setCurrencyModal(true);
										setShowBulkOptions(false);
									}}
								>
									Currency
								</div>
							</div>
						)}

						{headerDropDown === 'Inactive Vendor' && (
							<Button
								type="button"
								button="Mark as Active"
								className="mt-0 px-4 btn-gray"
								disabled={!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)}
								onClick={() => triggerConfirmationModal(1)}
							/>
						)}
						{headerDropDown === 'Active Vendor' && (
							<Button
								type="button"
								button="Mark as Inactive"
								className="mt-0 px-4 btn-gray"
								disabled={!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)}
								onClick={() => triggerConfirmationModal(2)}
							/>
						)}
						{headerDropDown === 'All Vendor' && (
							<>
								<Button
									type="button"
									button="Mark as Active"
									className="mt-0 px-4 btn-gray"
									disabled={!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)}
									onClick={() => triggerConfirmationModal(1)}
								/>
								<Button
									type="button"
									button="Mark as Inactive"
									className="mt-0 px-4 btn-gray"
									disabled={!hasPermission('purchases.vendors.edit', user?.role?.role_permissions)}
									onClick={() => triggerConfirmationModal(2)}
								/>
							</>
						)}
						<Button
							type="button"
							className="mt-0 btn-danger add-pro"
							button=""
							close
							onClick={() => {
								setShowBulkOptions(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 12,
						}}
					>
						<div className="dropdown text-end">
							<p
								className="d-block link-dark text-decoration-none dropdown-toggle"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{headerDropDown}
							</p>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a
										className="dropdown-item"
										onClick={() => FilterDatalist('All Vendor')}
									>
										All Vendor
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											FilterDatalist('Active Vendor');
										}}
									>
										Active Vendor
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											FilterDatalist('Draft Vendor');
										}}
									>
										Draft Vendor
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											FilterDatalist('Inactive Vendor');
										}}
									>
										Inactive Vendor
									</a>
								</li>
							</ul>
						</div>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('All Vendor');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<Button
									type="button"
									button="Advanced Filters"
									className="mt-0 px-4 btn-primary"
									onClick={() => setIsAdvanceFilterOpen(true)}
									icon={advanceFilterIcon}
								/>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-5"
							disabled={!hasPermission('purchases.vendors.create', user?.role?.role_permissions)}
							button="Create New Vendor"
							add
							onClick={() => navigateRouter(`/user/${suburl}/vendor-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img
									alt=""
									src={sortbydot}
								/>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li
									style={{
										padding: 10,
										textDecoration: 'none',
										color: '#212529',
										width: '100%',
										fontWeight: 'bold',
										cursor: 'not-allowed',
										marginBottom: '10px',
									}}
								>
									Sort By
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => handleSort({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => handleSort({ orderBy: 'vendor_display_name', sortBy: 'asc' })}
									>
										Vendor Display Name
										<span>{sortIconMap[sortDirection?.vendor_display_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => handleSort({ orderBy: 'vendor_id', sortBy: 'asc' })}
									>
										Vendor Id
										<span>{sortIconMap[sortDirection?.vendor_id]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => handleSort({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => handleSort({ orderBy: 'updated_at', sortBy: 'asc' })}
									>
										Last Modified Time
										<span>{sortIconMap[sortDirection?.updated_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('All Vendor');
											setVendorParams({
												page: 1,
												pageSize: 20,
												orderBy: null,
												sortBy: null,
												filter: {},
											});
										}}
									>
										Refresh
									</a>
								</li>
								{hasPermission('purchases.vendors.export', user?.role?.role_permissions) && (
									<li>
										<a
											className="dropdown-item"
											onClick={() => exportData('vendor')}
										>
											Export Vendor
										</a>
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>
			)}

			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Vendor');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon">
									<Plus width={15} />
								</span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>

			<VendorTable
				loader={loader}
				isAdvanceFilterApplied={isAdvanceFilterApplied}
				tableData={tableData}
				vendorColoum={vendorColumn}
				onRowClick={onRowClick}
				setBulkAction={setBulkAction}
				bulkAction={bulkAction}
				handleDeselectAll={handleDeselectAll}
				page={isAdvanceFilterApplied ? advanceFilterPage : vendorParams?.page}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : totalPages}
				setParams={(value) => {
					if (isAdvanceFilterApplied) {
						dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
					} else {
						setVendorParams((prev) => ({
							...prev,
							pageSize: value,
							page: 1,
						}));
					}
				}}
				pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : vendorParams?.pageSize}
				handlePageChange={handlePageChange}
				disabled={!hasPermission('purchases.vendors.create', user?.role?.role_permissions)}
				onClick={() => navigateRouter(`/user/${suburl}/vendor-create`)}
			/>

			{openPaymentTermsModal && (
				<VendorBulkPaymentTermModal
					openPaymentTermsModal={openPaymentTermsModal}
					setOpenPaymentTermsModal={setOpenPaymentTermsModal}
					getAllVendor={getAllVendor}
					setBulkAction={setBulkAction}
					bulkAction={bulkAction}
					handleBulkPaymentTermsUpdate={handleBulkPaymentTermsUpdate}
				/>
			)}

			{/* Confirmation Modal */}
			{isModalOpen && (
				<ConfirmationModal
					isOpen={isModalOpen}
					onClose={closeModal}
					title={getModalTitle()}
					content={getModalContent()}
					onCancel={closeModal}
					onOk={() => {
						handleIsActiveStatus(statusToUpdate);
						closeModal();
					}}
					loader={loader}
				/>
			)}

			{openCurrencyModal && (
				<VendorCurrencyModal
					openCurrencyModal={openCurrencyModal}
					setCurrencyModal={setCurrencyModal}
					handleBulkCurrencyUpdate={handleBulkCurrencyUpdate}
				/>
			)}

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<VendorAdvanceFilter
					handleOnFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					searchSelectedInputItems={searchSelectedInputItems}
					isAdvanceFilterModalOpen={isAdvanceFilterOpen}
					handleApplyFilters={handleApplyFilters}
					setIsAdvanceFilterModalOpen={setIsAdvanceFilterOpen}
				/>
			)}

			{isDeleteBulkConfirmationModalOpen && (
				<DeleteVendorModal
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteBulkConfirmationModalOpen}
					selectedVendorsListForDelete={selectedVendorsListForDelete}
					handleBulkDelete={handleBulkDelete}
					vendorLength={bulkAction.length}
				/>
			)}
		</div>
	);
};

export default Vendors;
